import { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Home from "./components/Home/Home";
import Partivcal from "./components/Hook/Partivcal";
import Blog from "./components/Page/Blog";
import Details from "./components/Page/Details";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/details/:id",
    element: <Details />,
    loader: ({ params }) =>
      fetch(`https://rahul-server.vercel.app/project/${params.id}`),
  },
]);

function App() {
  return (
    <div className="max-w-[1280px] mx-auto text-white">
      <Partivcal />
      <RouterProvider router={router}></RouterProvider>
      
      <Toaster position="bottom-center" reverseOrder={false} />
    </div>
  );
}

export default App;
